let activeUntil = 0;
export function previewDelay() { return performance.now() < activeUntil ? 0 : 130; }
export function warmPreviewIntent() { activeUntil = performance.now() + 700; }
